namespace $.$$ {
	export class $eve_app_page_components_radio extends $.$eve_app_page_components_radio {}
}

